import * as R from 'ramda';
import * as usersReducer from '../../core/reducers/users';

export default (state) => R.pipe(
  R.map(usersReducer.findById(state)),
)(state.organisation.users.items || []);
